import { render, staticRenderFns } from "./RequestSearch.vue?vue&type=template&id=0a6474a8&scoped=true"
import script from "./RequestSearch.vue?vue&type=script&lang=js"
export * from "./RequestSearch.vue?vue&type=script&lang=js"
import style0 from "./RequestSearch.vue?vue&type=style&index=0&id=0a6474a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6474a8",
  null
  
)

export default component.exports